var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isMember || _vm.notPay)?_c('div',{staticClass:"btn",on:{"click":_vm.handleClick}},[_vm._v("去使用")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }